import { useContext } from 'react';

import { DataDogContext } from './DataDogProvider';

export const useLogger = () => {
  const { addAction, addError, logger, setUserProperty } = useContext(DataDogContext);

  return { addAction, addError, logger, setUserProperty };
};
